export const calcDate = (date1, date2) => {
  var date3 = date2 - date1;

  var days = Math.floor(date3 / (24 * 3600 * 1000));

  var leave1 = date3 % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));

  var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));

  var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(date3 / 1000);
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

/**
 * 日期格式化
 */
export function dateFormat(value, format = "yyyy-MM-dd hh:mm:ss") {
  var date = new Date(Number(value));
  if (date !== "Invalid Date") {
    var o = {
      "M+": date.getMonth() + 1, // month
      "d+": date.getDate(), // day
      "h+": date.getHours(), // hour
      "m+": date.getMinutes(), // minute
      "s+": date.getSeconds(), // second
      "q+": Math.floor((date.getMonth() + 3) / 3), // quarter
      S: date.getMilliseconds(), // millisecond
    };
    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return format;
  }
  return "";
}

export function getLastDays(day = 90) {
  const end = new Date();
  end.setHours(23, 59, 59, 0);
  const start = new Date();
  start.setDate(start.getDate() - (day - 1)); // 含今天
  start.setHours(0, 0, 0, 0);
  return [dateFormat(start), dateFormat(end)];
}

/**
 * 根据格式化的日期字符串解析为 Date 对象。
 * @param {string} str - 日期字符串，例如 "2026-07-28 14:30:00"
 * @param {string} format - 字符串的格式，例如 "yyyy-MM-dd HH:mm:ss"，默认与 dateFormat 默认格式一致
 * @returns {Date} 解析成功返回 Date 对象，失败返回 null
 */
export function parseDate(str, format = 'yyyy-MM-dd HH:mm:ss') {
  if (!str) return null
  // 提取格式化中的占位符与实际值的映射关系
  const placeholders = {
    'yyyy': { len: 4, index: -1 },
    'MM': { len: 2, index: -1 },
    'dd': { len: 2, index: -1 },
    'HH': { len: 2, index: -1 },
    'mm': { len: 2, index: -1 },
    'ss': { len: 2, index: -1 }
  }
  // 找出每个占位符在 format 中的位置
  for (const key of Object.keys(placeholders)) {
    const idx = format.indexOf(key)
    if (idx !== -1) {
      placeholders[key].index = idx
    }
  }
  // 按位置顺序从字符串中取值
  const year = placeholders['yyyy'].index !== -1
    ? parseInt(str.substr(placeholders['yyyy'].index, 4), 10) : 0
  const month = placeholders['MM'].index !== -1
    ? parseInt(str.substr(placeholders['MM'].index, 2), 10) - 1 : 0
  const day = placeholders['dd'].index !== -1
    ? parseInt(str.substr(placeholders['dd'].index, 2), 10) : 1
  const hour = placeholders['HH'].index !== -1
    ? parseInt(str.substr(placeholders['HH'].index, 2), 10) : 0
  const minute = placeholders['mm'].index !== -1
    ? parseInt(str.substr(placeholders['mm'].index, 2), 10) : 0
  const second = placeholders['ss'].index !== -1
    ? parseInt(str.substr(placeholders['ss'].index, 2), 10) : 0

  const date = new Date(year, month, day, hour, minute, second)
  return isNaN(date.getTime()) ? null : date
}

